import React from 'react';
import ShipmentAddEditModal from './shipment-add-edit';
import ImportShipment from 'Core/modals/shipment/importshipment';
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { SHIPMENT_ADD_EDIT } = MODAL_TYPES;

const ShipmentModals = () => {
  return (
    <>
      <ShipmentAddEditModal modalId={SHIPMENT_ADD_EDIT} />
      <ImportShipment />
    </>
  );
};

export default ShipmentModals;
